import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Atom01 = function Atom01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.9995 12.0001h.01m3.5255 3.5356C10.8488 20.222 5.4669 22.438 3.5142 20.4854c-1.9526-1.9526.2635-7.3345 4.9498-12.0208S18.5322 1.5622 20.4848 3.515c1.9526 1.9526-.2635 7.3345-4.9498 12.0208m0-7.0713c4.6863 4.6863 6.9024 10.0682 4.9498 12.0208s-7.3346-.2634-12.0209-4.9497S1.5616 5.4673 3.5142 3.5147s7.3345.2634 12.0208 4.9497m-3.0355 3.5357a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    })
  }));
};
export default Atom01;